import {
    addComment, addReplyToComment,
    toggleCommentLike, toggleCommentDislike,
    toggleReplyLike, toggleReplyDislike
} from '@/store/slices/comments/commentsSlice';

import {
    addVideoCommentApiCall, addReplyToCommentApiCall,
    addReplyToReplyApiCall, commentLikeDislikeApiCall, replyLikeDislikeApiCall,
    updateUserPurchaseContentApiCall,
    updateWelcomeSeriesContentApiCall
} from "@/services/api"

import { handleRedirectToUserWebPageLoginPage } from '@/utils';
import { userWebsitePaths } from '@/constants/userWebsitePaths';

const userLoginPath = process.env.REACT_APP_USER_PANEL_URL + userWebsitePaths.login

export const handleAddVideoComment = async (payload: any, dispatch: any) => {
    const apiCallStatus = await addVideoCommentApiCall(payload);
    if (apiCallStatus.status
        && apiCallStatus.data
        && Object.entries(apiCallStatus.data).length > 0) {
        let commentData = apiCallStatus.data
        dispatch(addComment(commentData))
    }
    return apiCallStatus;
};

export const handleAddReplyToComment = async (payload: any, dispatch: any) => {
    const apiCallStatus = await addReplyToCommentApiCall(payload);
    if (apiCallStatus.status
        && apiCallStatus.data
        && Object.entries(apiCallStatus.data).length > 0) {
        let replyData = apiCallStatus.data
        dispatch(addReplyToComment({
            commentId: payload.commentId,
            reply: replyData,
        }));
    }
    return apiCallStatus;
}

export const handleAddReplyToReply = async (payload: any, dispatch: any) => {
    const apiCallStatus = await addReplyToReplyApiCall(payload);
    if (apiCallStatus.status
        && apiCallStatus.data
        && Object.entries(apiCallStatus.data).length > 0) {
        let replyData = apiCallStatus.data
        dispatch(addReplyToComment({
            commentId: payload.commentId,
            reply: replyData,
        }));
    }
    return apiCallStatus;
}


export const handleCommentLikeDislikeApiCall = async (payload: any, dispatch: any) => {
    const apiCallStatus = await commentLikeDislikeApiCall(payload);
    if (apiCallStatus.status) {
        if (payload.action === "like") {
            dispatch(toggleCommentLike(payload.commentId))
        } else {
            dispatch(toggleCommentDislike(payload.commentId))
        }
    }
    return apiCallStatus;
}

export const handleReplyLikeDislikeApiCall = async (payload: any, dispatch: any) => {
    const apiCallStatus = await replyLikeDislikeApiCall(payload);
    if (apiCallStatus.status) {
        if (payload.action === "like") {
            dispatch(toggleReplyLike(payload))
        } else {
            dispatch(toggleReplyDislike(payload))
        }
    }
    return apiCallStatus;
}

export const handleUpdateUserPurchaseContentApiCall = async (payload: any) => {
    let status = false
    const apiCallStatus = await updateUserPurchaseContentApiCall(payload);
    if (apiCallStatus.status) {
        status = true
    } else {
        handleRedirectToUserWebPageLoginPage("Issue while updating purchase content", true, userLoginPath)
    }
    return status;
}

export const handleUpdateWelcomeSeriesContentApiCall = async (payload: any) => {
    let status = false
    const apiCallStatus = await updateWelcomeSeriesContentApiCall(payload);
    if (apiCallStatus.status) {
        status = true
    } else {
        handleRedirectToUserWebPageLoginPage("Issue while updating purchase content", true, userLoginPath)
    }
    return status;
}

